import React, { Component, Fragment } from "react";

import Authentication from "../Authentication/Authentication";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actionCreators from "../../Store/actions/index";
import DetailP from "../../Component/DetailP/DetailP";
import MainToolBar from "../../Component/Navigation/MainToolBar/MainToolBar";
import BottomToolBar from "../../Component/Navigation/BottomToolBar/BottomToolBar";
import ContactNow from "../../Component/ContactNow/ContactNow";

class DetailPage extends Component {

    state = {
        itemToRetrive: null,
        searchInput: '',
        showMore: false,
        // Auth related :
        showAuth: false,
        authMode: 'signIn',
        user: null,
        //reload:
        reload: false
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        let itemToRetrive, vehicleType;
        for (let param of query.entries()) {
            if (param[0] === 'vehicle') {
                itemToRetrive = param[1]
            }
            if (param[0] === 'type') {
                vehicleType = param[1]
                localStorage.setItem('vehicleType', param[1]);
                if (vehicleType === 'car') {
                    vehicleType = 'cars';
                }
                else if (vehicleType === 'motor') {
                    vehicleType = 'motors';
                }
                else if (vehicleType === 'commercial') {
                    vehicleType = 'commercials';
                }
            }
            this.props.onChangeVehicleType(vehicleType)
        }

        this.setState({ itemToRetrive: itemToRetrive })
        this.props.onGetDetailItem(vehicleType, itemToRetrive);
        this.props.onGetFeatruedVehicles(vehicleType)

    }

    searchInputHandler = (value) => {
        this.setState({
            searchInput: value
        })
    }


    reLoadSearchPageHandler = () => {
        window.location.reload(false)
    }

    showMoreHandler = () => {
        this.setState((prevState) => {
            return { showMore: !prevState.showMore }
        })
    }

    showAuthHandler = (mode, kepShowing) => {
        if (kepShowing) {
            this.setState({ showAuth: true })
        } else {
            this.setState((prevState) => {
                return { showAuth: !prevState.showAuth }
            })
        }
        if (mode === 'signUp') {
            this.setState({
                authMode: 'signUp'
            })
        }
        else if (mode === 'signIn') {
            this.setState({
                authMode: 'signIn'
            })
        }
        else if (mode === 'passwordReset') {
            this.setState({
                authMode: 'passwordReset'
            })
        }
        else if (mode === 'verifyEmail') {
            this.setState({
                authMode: 'verifyEmail'
            })
        }
    }

    render() {
        return (
            <Fragment>
                {this.state.showAuth ?
                    <Authentication
                        showAuth={this.state.showAuth}
                        showAuthHandler={this.showAuthHandler}
                        authMode={this.state.authMode} />
                    :
                    null}
                <MainToolBar
                    props={{ ...this.props }}
                    reLoadSearchPage={this.reLoadSearchPageHandler}
                    searchInput={(value) => { this.searchInputHandler(value) }}
                    searchInputValue={this.state.searchInput}
                    showAuthHandler={this.showAuthHandler}
                    user={this.props.user}
                />
                <BottomToolBar changeType={(type) => { this.props.onChangeVehicleType(type) }} />
                <DetailP
                    vehicle={this.props.vehicle}
                    showMoreHandler={this.showMoreHandler}
                    showMore={this.state.showMore}
                    FeatruedVehicles={this.props.FeatruedVehicles}
                    hasVideo={this.props.hasVideo}
                    routeHistory={this.props.history}
                    itemLoading={this.props.itemLoading}
                    checkingHasVideo={this.props.checkingHasVideo}
                    user={this.props.user}
                    reloadPage={this.reLoadSearchPageHandler}
                    wishIdsArray={this.props.wishIdsArray}
                    itemToRetrive={this.state.itemToRetrive}
                    showAuthHandler={this.showAuthHandler}
                    AddItemToWishList={this.props.onAddItemToUserWishList}
                    addingItem={this.props.addingItem}
                />
                <ContactNow />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        vehicle: state.DetailP.vehicle,
        vehicleType: state.SearchP.vehicleType,
        FeatruedVehicles: state.landingP.feauredVechils,
        hasVideo: state.DetailP.hasVideo,
        itemLoading: state.DetailP.itemLoading,
        checkingHasVideo: state.DetailP.checkingHasVideo,
        // Auth related : 
        user: state.Auth.user,
        // WishList realted:
        wishIdsArray: state.WishList.wishIdsArray,
        addingItem: state.WishList.addingItem
    }
}

const mapDispathToPrpos = dispatch => {
    return {
        onChangeVehicleType: (type) => { dispatch(actionCreators.changeVehicleType(type)) },
        onGetDetailItem: (type, id) => { dispatch(actionCreators.getDetailItem(type, id)) },
        onGetFeatruedVehicles: (type) => { dispatch(actionCreators.getFeaturedVehicle(type)) },
        onAddItemToUserWishList: (itemId, token) => { dispatch(actionCreators.addItemToUserWishList(itemId, token)) },
    }
};

export default withRouter(connect(mapStateToProps, mapDispathToPrpos)(DetailPage));